module.exports = __webpack_public_path__ + "img/payment-batch.04072df0.svg";